import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import styles from './legal.module.scss';

interface LegalContentProps {
  legal: 'terms' | 'privacy' | string;
}

export const LegalContent = ({ legal }: LegalContentProps) => {
  const { t } = useTranslation();

  return (
    <>
      {legal === 'terms' && (
        <div className={styles.termsOfUse}>
          <Trans i18nKey="TERMS_OF_USE_CONTENT" />
          <div className={styles.link}>
            <a
              target="_blank"
              href="https://www.hitiq.com/conneqt-terms-of-use"
              rel="noopener noreferrer"
            >
              {t('TERMS_OF_USE_FULL_LINK')}
            </a>
          </div>
        </div>
      )}
      {legal === 'privacy' && (
        <div className={styles.termsOfUse}>
          <Trans i18nKey="PRIVACY_POLICY_CONTENT">
            <a
              className={styles.privacyLink}
              target="_blank"
              href="https://www.hitiq.com/privacy-policy"
              rel="noopener noreferrer"
            >
              placeholder_text
            </a>
          </Trans>
        </div>
      )}
    </>
  );
};
